module.exports = __webpack_public_path__ + "static/img/Gtu1@2x.f775448f.png";